/* eslint-disable import/prefer-default-export */

export const processSearchInput = (queryString) => {
  let input = queryString.replace(/\s+/g, ' ').trim();
  let isInvalidInput = false;
  let isInputAddress = false;

  if (input.search(/°/) !== -1) isInvalidInput = true;
  else if (input.match(/[A-Za-z]/) || input.match(/^\d{5}$/)) isInputAddress = true;
  else if (input.includes(',')) {
    input = input.replace(/,/, ' ').split(' ').filter((e) => e.trim().length);
    isInvalidInput = (input.length < 2 || input.length > 3);
  } else {
    input = input.split(/(\s+)/).filter((e) => e.trim().length);
    isInvalidInput = (input.length < 2 || input.length > 3);
  }

  return { isInvalidInput, isInputAddress, input };
};
